module.exports = __webpack_public_path__ + "static/img/unlimited@3x.b525e87e.png";